import { Utils, addDefinition, changeLanguage } from 'versafleet-core';

const { convertDataToParams, request } = Utils.RequestHelper;

const SUPPORTED_LANGUAGES = ['en', 'hi', 'id', 'ms', 'th', 'tl', 'vi', 'zh-CN'];
const importedLanguage = {};

async function setupLanguage(language) {
  if (language !== 'en' && !importedLanguage[language]) {
    let languageFile;
    switch (language) {
      case 'hi':
        languageFile = await import('languages/hi.json');
        break;
      case 'id':
        languageFile = await import('languages/id.json');
        break;
      case 'ms':
        languageFile = await import('languages/ms.json');
        break;
      case 'th':
        languageFile = await import('languages/th.json');
        break;
      case 'tl':
        languageFile = await import('languages/tl.json');
        break;
      case 'vi':
        languageFile = await import('languages/vi.json');
        break;
      case 'zh-CN':
        languageFile = await import('languages/zh-CN.json');
        break;
      default:
        break;
    }
    await addDefinition(language, languageFile.default);
    importedLanguage[language] = true;
  }
}

function receiveAccount(account) {
  return {
    type: 'RECEIVE_ACCOUNT',
    account,
  };
}

function receiveTimeWindows(timeWindows) {
  return {
    type: 'RECEIVE_TIME_WINDOWS',
    timeWindows,
  };
}

function receiveTimeWindowsAvailability(timeWindowsAvailability) {
  return {
    type: 'RECEIVE_TIME_WINDOWS_AVAILABILITY',
    timeWindowsAvailability,
  };
}

function receiveTrackingSetting(trackingSetting) {
  return {
    type: 'RECEIVE_TRACKING_SETTING',
    trackingSetting,
  };
}

function fetch() {
  return (dispatch, getState) => {
    request('/account', {
      method: 'GET',
    })
      .then(async (result) => {
        // Falls back to English if the account uses a language not yet supported by MJ
        const language = SUPPORTED_LANGUAGES.includes(result.account.language)
          ? result.account.language
          : 'en';

        if (language !== getState().account.language) {
          await setupLanguage(language);
          changeLanguage(language);
        }
        dispatch(receiveAccount(result.account));
        return result;
      });
  };
}

function fetchTimeWindows() {
  return async (dispatch) => {
    const result = await request('/account/time_windows', {
      method: 'GET',
    });
    dispatch(receiveTimeWindows(result.time_windows));
  };
}

// date can be a date string, or an array of max 2 date strings
function fetchTimeWindowsAvailability(date) {
  const query = {};
  if (Array.isArray(date)) {
    query.from_date = date[0];
    query.to_date = date[1] || date[0];
  } else {
    query.from_date = date;
    query.to_date = date;
  }
  return async (dispatch) => {
    const result = await request(`/account/time_windows_availability${convertDataToParams(query)}`, {
      method: 'GET',
    });
    dispatch(receiveTimeWindowsAvailability(result.time_windows_availability));
  };
}

function fetchTrackingSetting() {
  return async (dispatch) => {
    const result = await request('/account/tracking_setting', {
      method: 'GET',
    });
    dispatch(receiveTrackingSetting(result.tracking_setting));
  };
}

function changeLang(lang) {
  return {
    type: 'CHANGE_LANGUAGE',
    lang,
  };
}

export default {
  fetch,
  fetchTrackingSetting,
  fetchTimeWindows,
  fetchTimeWindowsAvailability,
  changeLang,
};
